import axios, { AxiosInstance } from "axios";
export const baseURL = `https://analytics-${process.env.REACT_APP_ENVIRONMENT}.ieqmax.io`;
const GrafanaClient = (): AxiosInstance => {
  const allLocalStorageData = { ...localStorage };
  Object.keys(allLocalStorageData).some((x: any) => {
    if (x.includes("accessToken")) {
      allLocalStorageData["accessToken"] = allLocalStorageData[x];
    }
  });
  const headers = {
    "Access-Control-Allow-Origin": "*",
    Authorization: allLocalStorageData?.accessToken,
  };
  return axios.create({
    baseURL,
    withCredentials: false,
    headers,
  });
};

export default GrafanaClient;
